<template>
  <el-dialog
    class="pop-box"
    :width ="width+'px'||'700px'"
    :visible.sync="isVisible"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :center="true"
    @closed="$emit('closeDialog')">
      <p class="dialog-title" slot="title">{{title}}</p>
       <slot></slot>
      <div v-if="!hasNotButton" slot="footer" class="dialog-footer">
        <el-button class="btnx-normal btn-gray" @click="$emit('cancel')">取 消</el-button>
        <el-button class="btnx-normal btn-general" @click="$emit('onSure')">确 定</el-button>
      </div>
  </el-dialog>
</template>
<script>
export default {
  name:'popBox',
  props:[
    'title',
    'width',
    'isScroll',
    'hasNotButton'
  ],
  data(){
    return{
      isVisible:false,
    }
  }
}
</script>
<style lang="scss">
  .pop-box{
    /*font-family:"Microsoft YaHei";*/
    .el-dialog{
      margin-top:50px !important;
      margin-bottom: 0px;
      font-size: 12px;
      background-color: #fff;
      input{
        height: 36px;
        width:100%;
        font-size: 12px;
        background-color: #FFF;
        border: 1px solid #E1E5E7;
        border-radius: 2px;
      }
      .el-dialog__header{
        padding: 0;
        .dialog-title{
          position: relative;
          height: 36px;
          line-height: 36px;
          text-align: center;
          color:#fff;
          background: #AABBD2;
        }
        .el-dialog__headerbtn{
          top: 10px;
          right: 8px;
          i:before{
            color:#fff;
            font-size: 16px;
          }
        }
      }
      .el-dialog__body{
        padding: 20px 0 0;
        .title-info{
          margin: 25px 18px 0;
          *{
            margin-left: 10px;
          }
        }
        .el-form{
          margin: auto;
          width: 95%;
          .el-col{
            width: 50%;
          }
          & >div {
            &:after{
              content: '';
              display: block;
              clear: both;
            }
          }
          .el-form-item.is-error{
            margin-bottom: 20px;
          }
          .el-form-item{
            width:100%;
            margin-bottom: 7px;
            display: block;
            .el-upload{
              line-height: 26px !important;
            }
            .el-form-item__label{
              padding: 0;
              font-size: 12px;
              color: #666;
              text-align: right;
              line-height: 42px;
              width: 100px;
            }
            .radio-wrapper{
              margin-left: 10px;
              position: relative;
              display: inline-block;
            }
            .el-form-item__content{
              width: 100%;
              .el-select,.el-cascader{
                width: calc(100% - 110px);
                .el-input{
                  width: 100%;
                  font-size: 12px;
                }
              }
              .el-radio__label{
                font-size: 12px;
              }
              .el-select__tags{
                margin-left: 10px;
              }
            }
            .el-input{
              margin-left: 10px;
              font-size: 12px;
              width:calc(100% - 110px);
            }
            .el-textarea{
              margin-left: 10px;
              width: calc(100% - 110px);
              height: 98px;
              .el-textarea__inner{
                height: 100%;
                font-size: 12px;
                resize: none;
              }
            }
            .upload-textarea{
              width: calc(100% - 145px);
            }
            .el-icon-upload{
              position: relative;
              top: -25px;
            }
          }
          .many-words{
            label{
              line-height: 20px !important;
            }
            .el-form-item__label{
              padding-left: 20px;
            }
          }
        }
        .detail-content{
          margin: auto;
          width: 95%;
          .item-wrapper{
            line-height: 36px;
            width:100%;
            .item-half{
              width: 50%;
              float: left;
              .item-content{
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              a{
                color:#0D74FE;
                text-underline: none;
                &:hover{
                  text-underline:#0D74FE;
                }
              }
            }
            &:after{
              content: '';
              display: block;
              clear: both;
            }
          }
          .detail-item{
            line-height: 36px;
            width:100%;
            .item-label{
              float: left;
              width:120px;
              text-align: right;
            }
            .item-title{
              font-weight: bold;
            }
            .item-content{
              margin-left: 8px;
              float: left;
              width:calc(100% - 130px);
              white-space: pre-wrap;
              word-wrap:break-word;
              word-break:break-all;
            }
            .pre-content{
              width: calc(100% - 30px);
              display: inline-block;
              vertical-align: middle;
              white-space: pre-wrap;
              word-wrap:break-word;
              word-break:break-all;
            }
            .item{
              vertical-align: middle;
            }
            &:after{
              content: '';
              display: block;
              clear: both;
            }
          }
        }
      }
      .el-dialog__footer{
        padding: 0;
      }
      .dialog-footer{
        margin-top: 10px;
        padding: 5px 0;
        clear: both;
        text-align: right;
        border-top: 1px solid #f1f3f4;
      }
    }
    .mustBe .el-form-item__label::before{
      content: "* ";
      color:red;
    }
    .h-line{
      margin: 20px 0;
      border-bottom:2px dotted #E1E5E7;
    }
    .popbox-table{
      margin: 8px 0;
      width: 100%;
      line-height: 32px;
      text-align: center;
      border-color:#EDF1F3;
      border-collapse: collapse;
      font-size: 12px !important;
      td,th{
        border: 1px solid #EDF1F3;
      }
      th{
        line-height: 34px;
      }
      thead{
        background-color: #AABBD2;
      }
      .el-form-item__content{
        margin-left: 0px !important;
        .el-input{
          width:98%;
          padding: 0;
          font-size: 12px;
          input{
            padding: 0 3px;
            width:100% !important;
          }
        }
      }
    }
    .el-pop-table{
      td{
        max-height:50px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/basics/popBox.vue